import { Gauge as MuiGauge, GaugeProps } from '@mui/x-charts';
import React from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';
import { useChartAnimation } from 'components/charts/hooks/use-chart-animation';

const GaugeChart = React.forwardRef<HTMLDivElement, GaugeProps & ChartSurfaceProps>(function GaugeChart(
  { skipAnimation, dark, text, ...props },
  ref
) {
  const chartSkipAnimation = useChartAnimation(skipAnimation);
  const { formatValue } = useChartLocale();

  return (
    <ChartThemeScope dark={dark}>
      <MuiGauge
        {...props}
        ref={ref}
        skipAnimation={chartSkipAnimation}
        text={text ?? (({ value }) => (value === null ? null : formatValue(value)))}
      />
    </ChartThemeScope>
  );
});

export default GaugeChart;
